import { Chip, type ChipProps, Tooltip } from "@mui/material";
import React, { type FC } from "react";
import { formatColorDifference } from "../../service/color-formatting";
import { ColorComparisonDialog } from "../dialog/ColorComparisonDialog";
import type { NamedColor } from "../filter/color-filter/ColorFilter";

export interface DeltaEDisplayProps extends ChipProps {
  preview: NamedColor;
  target: NamedColor;
}

export const DeltaEDisplay: FC<DeltaEDisplayProps> = ({
  preview,
  target,
  sx,
  ...chipProps
}) => {
  const [open, setOpen] = React.useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Tooltip arrow title={"Color Difference (ΔE)"}>
        <Chip
          {...chipProps}
          onClick={handleClickOpen}
          sx={{
            ...sx,
            backgroundColor: "rgba(183,183,183,0.19)",
          }}
          size="small"
          variant="filled"
          label={formatColorDifference(preview.deltaE || 0)}
        />
      </Tooltip>
      <ColorComparisonDialog
        preview={preview}
        target={target}
        open={open}
        onClose={handleClose}
      />
    </>
  );
};
